import { gql } from '@apollo/client/core';
import { Image as BaseImage } from '@react-pdf/renderer';
import React from 'react';

export default function ProductQRCode({
  collectionId,
  partnerId,
  productId,
  height = 80,
  width = 80,
}) {
  // Should test if qr codes are active for the event. However, this is not yet exposed on the GraphQL
  //   if (!hasContent()) return null;

  // We should move this off the server using a React-based QR code library
  return (
    <BaseImage
      src={`https://api.bottlebooks.me/qr/collections/${collectionId}/partners/${partnerId}/products/${productId}/qrcode.png`}
      style={{ height, width }}
    />
  );
}

// function hasContent({ collectionId, partnerId }) {
//   return !!vintage;
// }

ProductQRCode.fragment = gql`
  fragment ProductQRCode_RegisteredProduct on RegisteredProduct {
    collectionId
    partnerId
    productId
  }
`;
